import GameUsers from '../../components/GameManagement/GameUsers';

const GameUsersPage = () => {
	return <GameUsers />;
};

export default GameUsersPage;
